<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <path d="M21.552 1.76a1 1 0 0 0-1.455.025L8.06 15l-4.163-4.786a1 1 0 0 0-1.466-.046L.647 11.975a1 1 0 0 0-.046 1.354l6.718 7.81a1 1 0 0 0 1.502.015L23.374 4.968a1 1 0 0 0-.027-1.367l-1.795-1.84Z"/>
</svg>
